import SvgNoSlotsInfo from "./day-appointments-icons/SvgNoSlotsInfo";
import { useTranslation } from "@/hooks/localization/useTranslations";

const NoSlotsAvailable = () => {
  const t = useTranslation();
  return (
    <div className="no-slots-avialable">
      <SvgNoSlotsInfo />
      {t.no_slots_available}
    </div>
  );
};

export default NoSlotsAvailable;
